import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../../../providers';
import { PaymentAdsSubscriptionResponse, PaymentControllerImpl } from '../../../business';
import { PaymentPageFactoryImpl } from '../../api';

export function PaymentAdsPage({ navigate }) {
    const { userData, setCallbackLogin, handleLogout } = useAuth();
    const location = useLocation();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [paymentData, setPaymentData] = useState<PaymentAdsSubscriptionResponse | null>(null);
    const chosenPlan = location.state?.id;

    const factory = new PaymentPageFactoryImpl();
    const controller = new PaymentControllerImpl();

    useEffect(() => {
        const { username } = userData;
        if (username === "") {
            setCallbackLogin(
                {
                    goBack: true,
                    origin: '/ads/payment',
                    params: {
                        id: chosenPlan,
                    }
                }
            );
            navigate('/auth');
            return;
        }
        if (!chosenPlan) {
            navigate('/ads/subscribe');
            return;
        }
    }, [userData]);

    const fetchData = async () => {
        try {
            const response = await controller.onLoadAds(chosenPlan);
            setLoading(false);
            setPaymentData(response);
        } catch (error) {
            if (error === "401") {
                setCallbackLogin(
                    {
                        goBack: true,
                        origin: '/ads/payment',
                        params: {
                            id: chosenPlan,
                            frequency: location.state?.frequency
                        }
                    }
                );
                handleLogout();
                navigate('/auth');
            } else {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, [chosenPlan]);
    return (
        <>
            {isLoading ? <Spinner /> : factory.createAds(paymentData, location.state)}
        </>
    );
}